const NAMESPACE = 'AGGREGATE_PRICING_DATA';

const SET_DAILY_MINIMUM_PRICING_FOR_TRANS_MODE = `${NAMESPACE}/SET_DAILY_MINIMUM_PRICING_FOR_TRANS_MODE`;
const SET_DAILY_MINIMUM_PRICING = `${NAMESPACE}/SET_DAILY_MINIMUM_PRICING`;

export {
    SET_DAILY_MINIMUM_PRICING,
    SET_DAILY_MINIMUM_PRICING_FOR_TRANS_MODE,
};

export default NAMESPACE;
